import * as React from "react";
import { Table } from "../../../../newcomponents/table/table";
import { useTableKindId } from "../../../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../../../newcomponents/table/data/useTableItemQueryData";
import { TableHeaderRefreshButton } from "../../../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionNoLinkColumn } from "../../../../newcomponents/table/columns/wellKnown/nameDescriptionNoLinkColumn";
import { TagsColumn } from "../../../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { linksOf } from "../../../../services/cpln";
import { Secret } from "../../../../schema/types/secret";

interface SecretTableItem extends Secret {
  selfLink: string;
}

interface Props {
  title: string;
  selections: string[];
  onSelectionsChange: (values: string[]) => void;
}
export const SecretTable: React.FC<Props> = ({ title, selections, onSelectionsChange }) => {
  const { kind, id } = useTableKindId("secret", "policy-create-target-list-secret");
  const qData = useTableItemQueryData<Secret>(kind, { fetchAllPages: true });

  const secretTableItems = qData.visibleItems.map((secret) => {
    const selfLink = linksOf(secret).self!;

    return {
      ...secret,
      selfLink: selfLink,
    };
  });

  return (
    <Table<SecretTableItem>
      title={title}
      data={secretTableItems}
      tableId={id}
      selectMode="multi"
      selectKey={"selfLink"}
      selections={selections}
      onSelectionsChange={onSelectionsChange}
      headerRenderer={() => {
        return (
          <>
            <TableHeaderRefreshButton onClick={qData.fetchItems} />
            <CustomTableCPLNQuery
              tableId={id}
              kind={kind}
              onQuery={qData.setQuery}
              isLoading={qData.isLoadingQueried}
            />
          </>
        );
      }}
      enableFilter
      isLoading={qData.isLoading}
      columns={[
        NameDescriptionNoLinkColumn(),
        {
          id: "type",
          label: "Type",
          canGroupByDistinctValues: true,
          // TODO move to a central place
          groupLabelMap: {
            aws: "AWS",
            "azure-connector": "Azure Connector",
            "azure-sdk": "Azure SDK",
            docker: "Docker",
            dictionary: "Dictionary",
            ecr: "ECR",
            gcp: "GCP",
            keypair: "Keypair",
            "nats-account": "Nats Account",
            opaque: "Opaque",
            tls: "TLS",
            userpass: "Username & Password",
          },
          size: 200,
        },
        TagsColumn(),
        CreatedColumn(),
        LastModifiedColumn(),
      ]}
    />
  );
};
